import Vue from 'vue'
import i18n from 'vue-i18n'
import { Component, Prop } from 'vue-property-decorator'
import { DirectiveBinding } from 'vue/types/options'
import { VNode } from 'vue/types/umd'

import NodeWrapper from '../../components/NodeWrapper.vue'
import Socket from '../../components/Socket/OutputSocket.vue'
import CustomEditor from '../Editor/CustomEditor'

@Component({
  components: {
    Socket,
    NodeWrapper,
  },
  directives: {
    socket: {
      bind(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      },
      update(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
        (vnode.context as any).bindSocket(el, binding.arg, binding.value);
      }
    },
  }
})
export default class SampleNodeMixin extends Vue {
  @Prop() bindSocket!: DirectiveBinding

  @Prop() i18n!: i18n

  @Prop() editor!: CustomEditor

  getFormattedTime(time: number): string {
    const units = [
      60 * 60 * 24 * 30,
      60 * 60 * 24 * 7,
      60 * 60 * 24,
      60 * 60,
      60,
      1,
    ]

    if (time !== 0) {
      let result = ''

      let i = 0
      while (i < units.length && !result) {
        if (time % units[i] === 0) {
          result = (time / units[i]).toString() + ' ' + this.i18n.tc(`period_simplifier_${ units[i] }`, time / units[i]).toString()
        }

        i++
      }

      return result
    }

    return ` ${ time } ${ this.i18n.tc('period_simplifier_1', time).toString() }`
  }
}
